import React, { Component } from 'react'
import { connect } from 'react-redux'

import NotAllowed from '../components/NotAllowed'

export function isAllowed (allowedRoles, userRoles) {
  const isAllowedCbk = (prev, curr) =>
    (prev || allowedRoles.includes(curr))

  return userRoles.reduce(isAllowedCbk, false)
}

export function CreateAuthz (allowedRoles, whithNotAllowed = true, isConnectedComponent = true) {
  return function (WarappedComponent) {
    const decoratedWithAuthz = class extends Component {
      render () {
        if (!allowedRoles) return null
        // if (!allowedRoles) return (<WarappedComponent {...this.props}/>)
        const {
          roles = [],
          ...tail
        } = this.props

        const allowed = isAllowed(allowedRoles, roles)
        if (!allowed) {
          return (whithNotAllowed ? <NotAllowed /> : null)
        }
        if (!isConnectedComponent) {
          delete tail.dispatch
        }
        return <WarappedComponent {...tail} />
      }
    }

    const mapStateToProps = (state) => {
      return {
        roles: state.auth.roles
      }
    }

    const withRedux = connect(mapStateToProps)
    return withRedux(decoratedWithAuthz)
  }
}
